import {ApiUrls} from 'shared/config/model/urls';

import {createApi} from '@reduxjs/toolkit/query/react';
import {AxiosRequestHeaders} from 'axios';

import IHttpIncident from 'features/http/model/HttpIncident/IHttpIncident';
import IPagination from 'shared/api/model/IPagination';
import IHydraResponse from 'shared/api/model/HydraResponse';
import IOrderBy from 'shared/model/IOrderBy';
import {ISummaryHttpIncident} from 'features/http/model/HttpIncident/ISummaryHttpIncident';
import {providesList} from 'shared/api/rtk-query/RTKQueryHelper';
import httpBaseQuery from 'shared/api/rtk-query/httpBaseQuery';
import {buildQuery} from 'shared/api/query';
import {paginationAdapter} from 'shared/api/paginationHelper';

import ICollectionParams from '../../../shared/api/model/ICollectionParams';

export const httpIncidentAPI = createApi({
    reducerPath: 'httpIncidentAPI',
    baseQuery: httpBaseQuery(),
    tagTypes: ['HttpIncident', 'SummaryHttpIncident'],
    refetchOnMountOrArgChange: 60,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    endpoints: (build) => ({
        getHttpIncidents: build.query<IPagination<IHttpIncident>, {
            monitorId?: string,
            page?: number,
            sort?: IOrderBy,
            limit?: number,
        }>({
            query: ({monitorId, page, sort, limit = 0}) => ({
                path: buildQuery(ApiUrls.HTTP_INCIDENTS(monitorId, page, sort, limit)),
                headers: {Accept: 'application/ld+json'} as unknown as AxiosRequestHeaders,
            }),
            providesTags: (result) => providesList(result?.items, 'HttpIncident'),
            transformResponse(
                rawResult: IHydraResponse<IHttpIncident>,
            ): Promise<IPagination<IHttpIncident>> | IPagination<IHttpIncident> {
                return paginationAdapter(rawResult);
            },

        }),
        getSummaryHttpIncident: build.query<ISummaryHttpIncident, void>({
            query: () => ({
                path: ApiUrls.SUMMARY_HTTP_INCIDENTS,
            }),
            providesTags: ['SummaryHttpIncident'],
        }),

        getHttpIncidentsAll: build.query<IPagination<IHttpIncident>, ICollectionParams>({
            query: ({page, sort, filters}) => ({
                path: buildQuery(ApiUrls.HTTP_INCIDENTS_ALL(page, sort, filters)),
                headers: {Accept: 'application/ld+json'} as unknown as AxiosRequestHeaders,
            }),
            providesTags: (result) => providesList(result?.items, 'HttpIncident'),
            transformResponse(
                rawResult: IHydraResponse<IHttpIncident>,
            ): Promise<IPagination<IHttpIncident>> | IPagination<IHttpIncident> {
                return paginationAdapter(rawResult);
            },
        }),
    }),
});